import { DatasetType, Timestamp } from "./";
import { Decimal } from "decimal.js";

export interface MemberAccumulations {
  memberAccumulationsResults: {
    deductible: {
      end_date: Timestamp;
      family_amount: string;
      family_max_amount: string;
      individual_amount: string;
      individual_max_amount: string;
      start_date: Timestamp;
    };
    out_of_pocket: {
      end_date: Timestamp;
      family_amount: string;
      family_max_amount: string;
      individual_amount: string;
      individual_max_amount: string;
      start_date: Timestamp;
    };
    plan_pay: {
      end_date: Timestamp;
      family_amount: string;
      family_max_amount: string;
      individual_amount: string;
      individual_max_amount: string;
      start_date: Timestamp;
    };
  };
}

export interface AccumulationsModalContent {
  [deductible: string]: {
    topic: string;
    subject: string;
    description: string;
    label: string;
  };
  out_of_pocket: {
    topic: string;
    subject: string;
    description: string;
    label: string;
  };
  plan_pay: {
    topic: string;
    subject: string;
    description: string;
    label: string;
  };
}

export interface AccumulationDataset {
  [deductible: string]: DatasetType;
  out_of_pocket: DatasetType;
  plan_pay: DatasetType;
}

export enum DisplayPortion {
  Spent = "SPENT",
  Remaining = "REMAINING",
}

export interface AccumulationValues {
  readonly max: Decimal;
  readonly spent: Decimal;
  readonly remaining: Decimal;
}

export interface MoneyAccumulationValues extends AccumulationValues {
  readonly appliesTo: string[];
  readonly isEmbedded?: boolean;
}

export interface AccumulatorTypes {
  readonly deductible: MoneyAccumulationValues[];
  readonly outOfPocket: MoneyAccumulationValues[];
  readonly planPay: MoneyAccumulationValues[];
  readonly planPayFertility: MoneyAccumulationValues[];
}

export interface AccumulationScope {
  readonly family: AccumulatorTypes;
  readonly individual: AccumulatorTypes;
}

export interface AccumulationData {
  readonly inNetwork: AccumulationScope;
  readonly outOfNetwork?: AccumulationScope;
}

// recursively create mutable types except if its decimal 🙄︎
export type MutableType<T> = {
  -readonly [P in keyof T]: T[P] extends Decimal
    ? T[P]
    : T[P] extends object
      ? MutableType<T[P]>
      : T[P];
};

export type MutableAccumulationData = MutableType<AccumulationData>;

export enum DisplayScopes {
  Individual = "individual",
  Family = "family",
}

export enum DisplayNetworkStatuses {
  In = "inNetwork",
  Out = "outOfNetwork",
}

export enum Accumulators {
  Deductible = "deductible",
  OutOfPocket = "outOfPocket",
  PlanPay = "planPay",
  PlanPayFertility = "planPayFertility",
}
